jQuery(document).ready(function ($) {
    $('.videos').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 1000,
        fade: false
    })
})
